import { render } from "./InviteAthleteModal.vue?vue&type=template&id=647d572a&scoped=true"
import script from "./InviteAthleteModal.vue?vue&type=script&lang=js"
export * from "./InviteAthleteModal.vue?vue&type=script&lang=js"

import "./InviteAthleteModal.vue?vue&type=style&index=0&id=647d572a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647d572a"]])

export default __exports__